import type { TrackingCore } from "./core";

/**
 * Subscription cancel-flow funnel: survey → offer → confirm. These measure the
 * save rate of the retention flow (offer shown vs accepted vs cancelled) —
 * distinct from the booking-cancellation dialog events in booking.ts.
 * Merged onto the tracking singleton in index.ts.
 */
export const subscriptionEvents = {
  subCancelStarted(this: TrackingCore, entitlementId: string) {
    this.track("sub_cancel_started", {
      entitlement_id: entitlementId,
    });
  },

  subCancelReasonSelected(this: TrackingCore, reason: string) {
    this.track("sub_cancel_reason_selected", {
      reason,
    });
  },

  retentionOfferShown(this: TrackingCore, offerType: string, reason: string) {
    this.track("retention_offer_shown", {
      offer_type: offerType,
      reason,
    });
  },

  retentionOfferAccepted(
    this: TrackingCore,
    offerType: string,
    reason: string,
    pauseMonths?: number
  ) {
    this.track("retention_offer_accepted", {
      offer_type: offerType,
      reason,
      ...(pauseMonths ? { pause_months: pauseMonths } : {}),
    });
  },

  retentionOfferDeclined(this: TrackingCore, offerType: string, reason: string) {
    this.track("retention_offer_declined", {
      offer_type: offerType,
      reason,
    });
  },

  subCancelCompleted(this: TrackingCore, reason?: string) {
    this.track("sub_cancel_completed", {
      reason: reason ?? "skipped_survey",
    });
  },

  subCancelAbandoned(this: TrackingCore, step: string) {
    this.track("sub_cancel_abandoned", {
      step,
    });
  },

  subReactivated(this: TrackingCore, from: "pending_cancel" | "paused") {
    this.track("sub_reactivated", {
      reactivated_from: from,
    });
  },
};
